import { render, staticRenderFns } from "./bf-help-error.vue?vue&type=template&id=547bbe91&"
import script from "./bf-help-error.vue?vue&type=script&lang=js&"
export * from "./bf-help-error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports